import { Transaction } from 'prosemirror-state'
import { trackChangesKey } from './constants'
import { accept as coreAccept } from 'prose-core'

export function accept(uuid: string, tr: Transaction) {
  tr.setMeta(trackChangesKey, {
    disposition: { uuid },
  })
  coreAccept(uuid, tr)
}
